export enum UserType {
  UNKNOWN = 0,
  LEGAL = 7,
}
